import type { JonumMissingUserInfo } from '#src/__generated__/globalTypes.ts';

export enum AccountVerificationStep {
  INTRO = 'INTRO',
  DETAILS_FORM = 'DETAILS_FORM',
  WEEKLY_PLAY_TIME = 'WEEKLY_PLAY_TIME',
  WEEKLY_SPEND = 'WEEKLY_SPEND',
  IDENTITY_CTA = 'IDENTITY_CTA',
}

export type AccountVerificationData = {
  firstName: string;
  lastName: string;
  dateOfBirth: {
    month: string;
    day: string;
    year: string;
  };
  weeklyPlayTimeLimit: string;
  weeklySpendLimit: string;
};

export const MISSING_INFO_TO_STEP: Record<
  JonumMissingUserInfo,
  AccountVerificationStep
> = {
  FIRST_NAME: AccountVerificationStep.DETAILS_FORM,
  LAST_NAME: AccountVerificationStep.DETAILS_FORM,
  DATE_OF_BIRTH: AccountVerificationStep.DETAILS_FORM,
  PLAYTIME_LIMIT: AccountVerificationStep.WEEKLY_PLAY_TIME,
  SPENDING_LIMIT: AccountVerificationStep.WEEKLY_SPEND,
  KYC: AccountVerificationStep.IDENTITY_CTA,
  FIAT_WALLET: AccountVerificationStep.IDENTITY_CTA,
};
